// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./bBookFeedback.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./bBookLists.css";
import ___CSS_LOADER_AT_RULE_IMPORT_2___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./bBookReport.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ===== B-book design layer: tokens, shared components, settings page ===== */

/* Status colours tuned for WCAG AA on the admin surfaces: the theme's #22C55E green is 2.3:1 on white, too pale for text */
.b_book_page {
    --bb-gain: #15803D;
    --bb-loss: #B91C1C;
    --bb-warn: #B45309;
    --bb-book-b: #D97706;
    --bb-series-3: #0F766E;
    --bb-ok-badge: #15803D;
    --bb-alert-badge: #B91C1C;
    --bb-soft: var(--text-secondary);
    --bb-focus: var(--primary);
    --bb-space-1: 4px;
    --bb-space-2: 8px;
    --bb-space-3: 12px;
    --bb-space-4: 16px;
    --bb-space-5: 24px;
    --bb-space-6: 32px;
}

[data-theme="dark"] .b_book_page {
    --bb-gain: #4ADE80;
    --bb-loss: #F87171;
    --bb-warn: #FBBF24;
    --bb-book-b: #FBBF24;
    --bb-series-3: #2DD4BF;
}

/* keyboard users see where they are: the global stylesheet removes every outline */
.b_book_page :is(button, a, [role="switch"], summary):focus-visible,
.b_book_page .b_book_toggle .toggle-checkbox:focus-visible + .toggle-switch {
    outline: 2px solid var(--bb-focus);
    outline-offset: 2px;
}

.b_book_page .tableau_body_item,
.b_book_page .b_book_num {
    font-variant-numeric: tabular-nums;
}

@media (prefers-reduced-motion: reduce) {
    .b_book_page *,
    .b_book_page *::before,
    .b_book_page *::after {
        transition-duration: 0.01ms !important;
        animation-duration: 0.01ms !important;
    }
}

.b_book_page .b_book_visually_hidden {
    position: absolute;
    width: 1px;
    height: 1px;
    overflow: hidden;
    clip: rect(0 0 0 0);
    white-space: nowrap;
}

.b_book_page .b_book_icon {
    flex-shrink: 0;
}

/* ----- page structure ----- */

.b_book_page .b_book_title_component {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    width: 100%;
    justify-content: space-between;
    align-items: center;
    gap: var(--bb-space-3);
    margin: var(--bb-space-6) 0 var(--bb-space-2);
}

.b_book_page .b_book_title_component:first-child {
    margin-top: 0;
}

.b_book_page .b_book_title_component h2 {
    margin: 0;
    font-size: 20px;
    font-weight: 600;
}

.b_book_page_title {
    margin: 0;
    font-size: 24px;
    font-weight: 700;
    letter-spacing: -0.01em;
    color: var(--text-primary);
}

.b_book_page .b_book_hint {
    margin: 0 0 var(--bb-space-4);
    max-width: 75ch;
    font-size: 13px;
    line-height: 1.5;
    color: var(--bb-soft);
}

.b_book_page .b_book_card {
    display: flex;
    flex-direction: column;
    gap: var(--bb-space-4);
    background-color: var(--bg-card);
    border: 1px solid var(--border);
    border-radius: var(--radius-md);
    box-shadow: var(--shadow-sm);
    padding: var(--bb-space-5);
    margin-bottom: var(--bb-space-5);
}

.b_book_page .b_book_card .table-container,
.b_book_page .b_book_card .table-column {
    width: 100%;
}

/* ----- buttons: one primary per form, quiet row actions, destructive ones in red ----- */

.b_book_page .b_book_action_button,
.b_book_page .b_book_secondary_button,
.b_book_page .b_book_row_button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: var(--bb-space-2);
    min-height: 36px;
    padding: 0 var(--bb-space-4);
    border-radius: var(--radius-sm);
    font-size: 14px;
    font-weight: 600;
    white-space: nowrap;
    cursor: pointer;
    transition: background-color 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease;
}

.b_book_page .b_book_action_button {
    background-color: var(--primary);
    border: 1px solid var(--primary);
    color: #fff;
}

.b_book_page .b_book_action_button:hover:not(:disabled) {
    background-color: var(--primary-hover);
    box-shadow: var(--shadow-sm);
}

.b_book_page .b_book_action_button.b_book_danger_button {
    background-color: var(--bb-loss);
    border-color: var(--bb-loss);
}

[data-theme="dark"] .b_book_page .b_book_action_button.b_book_danger_button {
    color: #1E293B;
}

.b_book_page .b_book_secondary_button {
    background-color: transparent;
    border: 1px solid var(--border);
    color: var(--text-primary);
}

.b_book_page .b_book_secondary_button:hover:not(:disabled) {
    background-color: var(--bg);
}

.b_book_page .b_book_row_button {
    min-height: 32px;
    padding: 0 var(--bb-space-3);
    font-size: 13px;
    background-color: transparent;
    border: 1px solid var(--border);
    color: var(--text-primary);
}

.b_book_page .b_book_row_button:hover:not(:disabled) {
    background-color: var(--bg);
    border-color: var(--text-secondary);
}

.b_book_page .b_book_row_button_danger {
    color: var(--bb-loss);
    border-color: color-mix(in srgb, var(--bb-loss) 40%, transparent);
}

.b_book_page .b_book_row_button_danger:hover:not(:disabled) {
    background-color: var(--danger-light);
    border-color: var(--bb-loss);
}

.b_book_page .b_book_action_button:disabled,
.b_book_page .b_book_secondary_button:disabled,
.b_book_page .b_book_row_button:disabled {
    opacity: 0.45;
    cursor: not-allowed;
}

.b_book_page .b_book_link_button {
    background: none;
    padding: 0;
    color: var(--primary);
    font: inherit;
    font-weight: 600;
    text-decoration: underline;
    cursor: pointer;
}

/* ----- settings: status card ----- */

.b_book_page .b_book_status_row {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    gap: var(--bb-space-3);
}

.b_book_page .b_book_card > .b_book_status_row ~ .b_book_status_row {
    padding-top: var(--bb-space-5);
    border-top: 1px solid var(--border);
}

.b_book_page .b_book_status_row_top {
    align-items: flex-start;
}

.b_book_page .b_book_status_label {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 10px;
    min-width: 200px;
}

.b_book_page .b_book_status_label p {
    margin: 0;
    font-weight: 600;
    color: var(--text-primary);
}

.b_book_page .b_book_row_hint {
    margin: calc(var(--bb-space-2) * -1) 0 0;
    font-size: 13px;
    color: var(--bb-soft);
}

.b_book_page .b_book_toggle {
    position: relative;
}

/* the shared toggle hides its checkbox with visibility, which also removes it from the keyboard: keep it focusable, just invisible */
.b_book_page .b_book_toggle .toggle-checkbox {
    visibility: visible;
    opacity: 0;
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    margin: 0;
    cursor: pointer;
    z-index: 1;
}

.b_book_page .b_book_toggle_disabled {
    opacity: 0.6;
    pointer-events: none;
}

.b_book_page .b_book_brakes_block {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: var(--bb-space-2);
    flex: 1 1;
}

.b_book_page .b_book_brakes {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: var(--bb-space-2);
}

.b_book_page .b_book_brake_notes {
    list-style: none;
    margin: 0;
    padding: 0;
    gap: var(--bb-space-1);
    max-width: 60ch;
    font-size: 13px;
    color: var(--bb-warn);
}

.b_book_page .b_book_brake_notes li {
    display: flex;
    align-items: flex-start;
    gap: 6px;
    width: auto;
}

.b_book_page .b_book_brake_notes .b_book_icon {
    margin-top: 2px;
}

/* ----- forms ----- */

.b_book_page .b_book_form_row {
    display: block;
    border: 0;
    margin: 0;
    padding: 0;
    min-width: 0;
}

.b_book_page .b_book_form_row > legend {
    float: left;
    padding: 0;
    margin: 0;
}

.b_book_page .b_book_form_fields {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
    justify-content: flex-end;
    gap: var(--bb-space-4) var(--bb-space-5);
}

.b_book_page .b_book_field {
    display: flex;
    flex-direction: column;
    gap: 6px;
    width: 220px;
}

.b_book_page .b_book_field_label {
    font-size: 13px;
    font-weight: 600;
    color: var(--text-primary);
}

.b_book_page .b_book_field_control {
    position: relative;
}

.b_book_page .b_book_field_control input {
    width: 100%;
    min-height: 40px;
    padding-right: 32px;
    background-color: var(--bg);
    font-variant-numeric: tabular-nums;
}

.b_book_page .b_book_field_control input {
    -moz-appearance: textfield; /* the spinner arrows sit on top of the unit */
}

.b_book_page .b_book_field_control input::-webkit-inner-spin-button,
.b_book_page .b_book_field_control input::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

.b_book_page .b_book_field_invalid input {
    border-color: var(--bb-loss);
}

.b_book_page .b_book_field_invalid input:focus {
    box-shadow: 0 0 0 3px var(--danger-light);
}

.b_book_page .b_book_field_unit {
    position: absolute;
    right: 12px;
    top: 50%;
    transform: translateY(-50%);
    font-size: 14px;
    color: var(--bb-soft);
    pointer-events: none;
}

.b_book_page .b_book_field_helper,
.b_book_page .b_book_field_error {
    margin: 0;
    font-size: 12px;
    line-height: 1.45;
}

.b_book_page .b_book_field_helper {
    color: var(--bb-soft);
}

.b_book_page .b_book_field_error {
    color: var(--bb-loss);
    font-weight: 500;
}

.b_book_page .b_book_form_submit {
    margin-top: 25px; /* lines up with the inputs, under their labels */
}

.b_book_page .b_book_error_text {
    margin: 0;
    font-size: 13px;
    color: var(--bb-loss);
}

.b_book_page .b_book_inline_error {
    margin: 0 0 var(--bb-space-4);
}

/* table cell inputs (spreads) */
.b_book_page .b_book_exposure_input {
    width: 140px;
    min-height: 36px;
    background-color: var(--bg);
    font-variant-numeric: tabular-nums;
}

.b_book_page .b_book_exposure_input.b_book_input_invalid {
    border-color: var(--bb-loss);
}

.b_book_page .b_book_add_row {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: flex-start;
    gap: var(--bb-space-3);
}

.b_book_page .b_book_add_row .search_user_container,
.b_book_page .b_book_add_row .search_ticker_container {
    flex: 1 1;
    min-width: 240px;
    max-width: 420px;
}

.b_book_page .b_book_position_gain {
    color: var(--bb-gain);
    font-weight: 600;
}

.b_book_page .b_book_position_loss {
    color: var(--bb-loss);
    font-weight: 600;
}

/* ----- responsive ----- */

@media (max-width: 1100px) {
    .b_book_page .b_book_form_row > legend {
        width: 100%; /* still floated: a legend that is not floated sits inside the fieldset border, struck through */
        margin-bottom: var(--bb-space-3);
    }

    .b_book_page .b_book_form_fields {
        clear: both;
        justify-content: flex-start;
    }

    .b_book_page .b_book_brakes_block {
        align-items: flex-start;
    }
}

@media (max-width: 768px) {
    .b_book_page .b_book_card {
        padding: var(--bb-space-4);
    }

    .b_book_page .b_book_field {
        width: 100%;
    }

    .b_book_page .b_book_form_submit {
        margin-top: 0;
        width: 100%;
    }

    .b_book_page .b_book_add_row .search_user_container,
    .b_book_page .b_book_add_row .search_ticker_container {
        max-width: none;
    }
}

/* house statement: one flow per line, amount right-aligned */
.b_book_page .b_book_ledger_lines {
    display: flex;
    flex-direction: column;
    gap: var(--bb-space-2);
    margin: 0;
}

.b_book_page .b_book_ledger_line {
    display: flex;
    justify-content: space-between;
    gap: var(--bb-space-3);
    padding-bottom: var(--bb-space-2);
    border-bottom: 1px solid var(--border);
}

.b_book_page .b_book_ledger_line dd {
    margin: 0;
    font-weight: 600;
}

/* ===== 2026-10 refresh: one tab bar across the screens, softer surfaces, denser tables, pill buttons ===== */

.b_book_page {
    --bb-radius-lg: 16px;
    --bb-radius-md: 12px;
    --bb-shadow-card: 0 1px 2px rgba(15, 23, 42, 0.04), 0 8px 24px -16px rgba(15, 23, 42, 0.18);
    --bb-surface-2: color-mix(in srgb, var(--bg-card) 92%, var(--text-primary) 8%);
    --bb-accent-soft: color-mix(in srgb, var(--primary) 12%, transparent);
    /* no width cap: on a wide screen the tables spread out instead of scrolling inside their card; prose keeps its own ch limits */
}

[data-theme="dark"] .b_book_page {
    --bb-shadow-card: 0 1px 2px rgba(0, 0, 0, 0.3), 0 12px 32px -20px rgba(0, 0, 0, 0.7);
}

.b_book_page .b_book_page_title {
    font-size: 26px;
    letter-spacing: -0.02em;
}

.b_book_page .b_book_page_lede {
    margin-top: calc(var(--bb-space-2) * -1);
    max-width: 90ch;
}

.b_book_page .b_book_nav {
    display: flex;
    flex-wrap: wrap;
    gap: var(--bb-space-1);
    width: -moz-fit-content;
    width: fit-content;
    max-width: 100%;
    margin: 0 0 var(--bb-space-5);
    padding: 4px;
    background-color: var(--bb-surface-2);
    border-radius: 999px;
}

.b_book_page .b_book_nav_tab {
    display: inline-flex;
    align-items: center;
    min-height: 34px;
    padding: 0 var(--bb-space-4);
    border-radius: 999px;
    font-size: 13px;
    font-weight: 600;
    color: var(--bb-soft);
    text-decoration: none;
    white-space: nowrap;
    transition: background-color 0.15s ease, color 0.15s ease;
}

.b_book_page .b_book_nav_tab:hover {
    color: var(--text-primary);
}

.b_book_page .b_book_nav_tab_active {
    background-color: var(--bg-card);
    color: var(--text-primary);
    box-shadow: var(--shadow-sm);
}

.b_book_page .b_book_card,
.b_book_page .b_book_report_card {
    border-radius: var(--bb-radius-lg);
    box-shadow: var(--bb-shadow-card);
}

.b_book_page .b_book_title_component h2 {
    font-size: 18px;
    letter-spacing: -0.01em;
}

.b_book_page .b_book_count {
    display: inline-flex;
    align-items: center;
    min-height: 22px;
    margin-left: var(--bb-space-2);
    padding: 0 8px;
    border-radius: 999px;
    background-color: var(--bb-accent-soft);
    color: var(--primary);
    font-size: 12px;
    font-weight: 700;
    vertical-align: middle;
}

/* KPI tiles: bigger figure, a tone bar on the left instead of colour on the text alone */
.b_book_page .b_book_kpi {
    position: relative;
    padding: 18px 20px 18px 22px;
    border-radius: var(--bb-radius-md);
    box-shadow: var(--bb-shadow-card);
    overflow: hidden;
}

.b_book_page .b_book_kpi::before {
    content: '';
    position: absolute;
    inset: 0 auto 0 0;
    width: 4px;
    background-color: var(--border);
}

.b_book_page .b_book_kpi:has(.b_book_kpi_gain)::before { background-color: var(--bb-gain); }
.b_book_page .b_book_kpi:has(.b_book_kpi_loss)::before { background-color: var(--bb-loss); }

.b_book_page .b_book_kpi_value {
    font-size: 28px;
}

/* tables: quieter chrome, sticky header, hover row, numbers to the right */
.b_book_page .tableau_head_item_th {
    position: sticky;
    top: 0;
    z-index: 1;
    background-color: var(--bg-card);
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: var(--bb-soft);
    border-bottom: 1px solid var(--border);
}

.b_book_page .tableau_body_row {
    transition: background-color 0.12s ease;
}

.b_book_page .tableau_body_row:hover {
    background-color: var(--bb-surface-2);
}

.b_book_page .tableau_body_item {
    border-bottom: 1px solid color-mix(in srgb, var(--border) 60%, transparent);
    padding-top: 10px;
    padding-bottom: 10px;
}

.b_book_page .tableau_body_item:has(> .b_book_num) {
    text-align: right;
}

/* buttons: pills, the primary one slightly lifted */
.b_book_page .b_book_action_button,
.b_book_page .b_book_secondary_button,
.b_book_page .b_book_row_button {
    border-radius: 999px;
}

.b_book_page .b_book_action_button {
    box-shadow: 0 1px 2px rgba(15, 23, 42, 0.12);
}

.b_book_page .b_book_action_button:hover:not(:disabled) {
    transform: translateY(-1px);
}

.b_book_page .b_book_row_button:hover:not(:disabled) {
    background-color: var(--bb-accent-soft);
    border-color: transparent;
    color: var(--primary);
}

.b_book_page .b_book_row_button_danger:hover:not(:disabled) {
    background-color: color-mix(in srgb, var(--bb-loss) 10%, transparent);
    color: var(--bb-loss);
}

/* inputs and selects share the pill language */
.b_book_page .b_book_field_control input,
.b_book_page .b_book_chip_input,
.b_book_page .b_book_toolbar select,
.b_book_page .b_book_toolbar input {
    border-radius: 10px;
}

@media (max-width: 900px) {
    .b_book_page .b_book_nav {
        width: 100%;
        border-radius: var(--bb-radius-md);
    }
}

/* the app bar: tabs on the left, refresh on the right; it stays put while the screen below changes (no entrance animation: a stuck one would hide the screen) */
.b_book_page .b_book_appbar {
    position: sticky;
    top: 0;
    z-index: 3;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: var(--bb-space-3);
    margin: 0 0 var(--bb-space-5);
    padding: 4px 0;
    background-color: color-mix(in srgb, var(--bg) 85%, transparent);
    -webkit-backdrop-filter: blur(6px);
            backdrop-filter: blur(6px);
}

.b_book_page .b_book_appbar .b_book_nav {
    margin: 0;
}

.b_book_page .b_book_refresh {
    display: inline-flex;
    align-items: center;
    gap: var(--bb-space-2);
    min-height: 36px;
    padding: 0 var(--bb-space-4);
    border: 1px solid var(--border);
    border-radius: 999px;
    background-color: var(--bg-card);
    color: var(--text-primary);
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
    transition: background-color 0.15s ease, border-color 0.15s ease;
}

.b_book_page .b_book_refresh:hover {
    background-color: var(--bb-accent-soft);
    border-color: transparent;
    color: var(--primary);
}

.b_book_page .b_book_refresh_spinning .b_book_icon {
    animation: b_book_spin 0.8s linear infinite;
}

@keyframes b_book_spin {
    to { transform: rotate(360deg); }
}

.b_book_page .b_book_pending {
    display: inline-flex;
    align-items: center;
    gap: var(--bb-space-2);
    padding: 6px 12px;
    border-radius: 999px;
    background-color: var(--bb-accent-soft);
    color: var(--primary);
}

/* a figure with a note under it, inside a table cell */
.b_book_page .b_book_stack {
    display: inline-flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 2px;
}

.b_book_page .b_book_cell_hint {
    margin: 0;
    font-size: 11px;
    white-space: nowrap;
}

/* ledger lines: the amount never wraps, the label gives way */
.b_book_page .b_book_ledger_line dt {
    min-width: 0;
}

.b_book_page .b_book_ledger_line dd {
    flex-shrink: 0;
    white-space: nowrap;
}

/* a fold for the detail nobody needs at a glance */
.b_book_page .b_book_details {
    margin: 0 0 var(--bb-space-5);
}

.b_book_page .b_book_details > summary {
    display: inline-flex;
    align-items: center;
    gap: var(--bb-space-2);
    margin-bottom: var(--bb-space-4);
    padding: 6px 14px;
    border: 1px solid var(--border);
    border-radius: 999px;
    font-size: 13px;
    font-weight: 600;
    color: var(--text-primary);
    cursor: pointer;
    list-style: none;
}

.b_book_page .b_book_details > summary::-webkit-details-marker {
    display: none;
}

.b_book_page .b_book_details > summary::before {
    content: '+';
    font-weight: 700;
}

.b_book_page .b_book_details[open] > summary::before {
    content: '−';
}


/* ===== responsive page: the (i) of a section title sits beside it, the app bar stacks on narrow screens ===== */

.b_book_page .b_book_title_component .b_book_info {
    position: static;
    margin-right: auto; /* title and its (i) on the left, the live stamp on the right */
}

.b_book_page .b_book_title_component h2 {
    margin-right: var(--bb-space-1);
}

@media (max-width: 900px) {
    .b_book_page .b_book_appbar {
        flex-wrap: wrap;
    }

    .b_book_page .b_book_appbar .b_book_nav {
        flex-wrap: nowrap;
        overflow-x: auto;
        -webkit-overflow-scrolling: touch;
        scrollbar-width: none;
    }

    .b_book_page .b_book_appbar .b_book_nav::-webkit-scrollbar {
        display: none;
    }

    .b_book_page .b_book_appbar .b_book_refresh {
        margin-left: auto;
    }

    .b_book_page .b_book_title_component {
        gap: var(--bb-space-2);
    }
}
`, "",{"version":3,"sources":["webpack://./src/pages/bBook/bBook.css"],"names":[],"mappings":"AAIA,8EAA8E;;AAE9E,2HAA2H;AAC3H;IACI,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,oBAAoB;IACpB,sBAAsB;IACtB,sBAAsB;IACtB,yBAAyB;IACzB,gCAAgC;IAChC,0BAA0B;IAC1B,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,oBAAoB;IACpB,sBAAsB;AAC1B;;AAEA,mFAAmF;AACnF;;IAEI,kCAAkC;IAClC,mBAAmB;AACvB;;AAEA;;IAEI,kCAAkC;AACtC;;AAEA;IACI;;;QAGI,sCAAsC;QACtC,qCAAqC;IACzC;AACJ;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA,+BAA+B;;AAE/B;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,WAAW;IACX,8BAA8B;IAC9B,mBAAmB;IACnB,sBAAsB;IACtB,6CAA6C;AACjD;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,SAAS;IACT,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,uBAAuB;IACvB,0BAA0B;AAC9B;;AAEA;IACI,6BAA6B;IAC7B,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,sBAAsB;IACtB,gCAAgC;IAChC,+BAA+B;IAC/B,+BAA+B;IAC/B,4BAA4B;IAC5B,0BAA0B;IAC1B,gCAAgC;AACpC;;AAEA;;IAEI,WAAW;AACf;;AAEA,0FAA0F;;AAE1F;;;IAGI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;IACtB,gBAAgB;IAChB,4BAA4B;IAC5B,+BAA+B;IAC/B,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,uFAAuF;AAC3F;;AAEA;IACI,gCAAgC;IAChC,gCAAgC;IAChC,WAAW;AACf;;AAEA;IACI,sCAAsC;IACtC,4BAA4B;AAChC;;AAEA;IACI,gCAAgC;IAChC,4BAA4B;AAChC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,6BAA6B;IAC7B,+BAA+B;IAC/B,0BAA0B;AAC9B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,gBAAgB;IAChB,4BAA4B;IAC5B,eAAe;IACf,6BAA6B;IAC7B,+BAA+B;IAC/B,0BAA0B;AAC9B;;AAEA;IACI,2BAA2B;IAC3B,mCAAmC;AACvC;;AAEA;IACI,qBAAqB;IACrB,iEAAiE;AACrE;;AAEA;IACI,qCAAqC;IACrC,4BAA4B;AAChC;;AAEA;;;IAGI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,qBAAqB;IACrB,aAAa;IACb,gBAAgB;IAChB,0BAA0B;IAC1B,eAAe;AACnB;;AAEA,sCAAsC;;AAEtC;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,8BAA8B;IAC9B,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,8BAA8B;IAC9B,mCAAmC;AACvC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,SAAS;IACT,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,wCAAwC;IACxC,eAAe;IACf,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;AACtB;;AAEA,qIAAqI;AACrI;IACI,mBAAmB;IACnB,UAAU;IACV,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,SAAS;IACT,eAAe;IACf,UAAU;AACd;;AAEA;IACI,YAAY;IACZ,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,qBAAqB;IACrB,sBAAsB;IACtB,SAAO;AACX;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,SAAS;IACT,UAAU;IACV,sBAAsB;IACtB,eAAe;IACf,eAAe;IACf,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,QAAQ;IACR,WAAW;AACf;;AAEA;IACI,eAAe;AACnB;;AAEA,sBAAsB;;AAEtB;IACI,cAAc;IACd,SAAS;IACT,SAAS;IACT,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,UAAU;IACV,SAAS;AACb;;AAEA;IACI,aAAa;IACb,eAAe;IACf,uBAAuB;IACvB,yBAAyB;IACzB,wCAAwC;AAC5C;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,mBAAmB;IACnB,2BAA2B;IAC3B,kCAAkC;AACtC;;AAEA;IACI,0BAA0B,EAAE,8CAA8C;AAC9E;;AAEA;;IAEI,wBAAwB;IACxB,SAAS;AACb;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,2BAA2B;IAC3B,eAAe;IACf,qBAAqB;IACrB,oBAAoB;AACxB;;AAEA;;IAEI,SAAS;IACT,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB,EAAE,iDAAiD;AACvE;;AAEA;IACI,SAAS;IACT,eAAe;IACf,qBAAqB;AACzB;;AAEA;IACI,6BAA6B;AACjC;;AAEA,gCAAgC;AAChC;IACI,YAAY;IACZ,gBAAgB;IAChB,2BAA2B;IAC3B,kCAAkC;AACtC;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,uBAAuB;IACvB,sBAAsB;AAC1B;;AAEA;;IAEI,SAAO;IACP,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA,2BAA2B;;AAE3B;IACI;QACI,WAAW,EAAE,gGAAgG;QAC7G,gCAAgC;IACpC;;IAEA;QACI,WAAW;QACX,2BAA2B;IAC/B;;IAEA;QACI,uBAAuB;IAC3B;AACJ;;AAEA;IACI;QACI,0BAA0B;IAC9B;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,aAAa;QACb,WAAW;IACf;;IAEA;;QAEI,eAAe;IACnB;AACJ;;AAEA,6DAA6D;AAC7D;IACI,aAAa;IACb,sBAAsB;IACtB,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,sBAAsB;IACtB,iCAAiC;IACjC,sCAAsC;AAC1C;;AAEA;IACI,SAAS;IACT,gBAAgB;AACpB;;AAEA,8GAA8G;;AAE9G;IACI,oBAAoB;IACpB,oBAAoB;IACpB,2FAA2F;IAC3F,8EAA8E;IAC9E,qEAAqE;IACrE,+HAA+H;AACnI;;AAEA;IACI,oFAAoF;AACxF;;AAEA;IACI,eAAe;IACf,uBAAuB;AAC3B;;AAEA;IACI,wCAAwC;IACxC,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,sBAAsB;IACtB,uBAAkB;IAAlB,kBAAkB;IAClB,eAAe;IACf,6BAA6B;IAC7B,YAAY;IACZ,qCAAqC;IACrC,oBAAoB;AACxB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,gBAAgB;IAChB,4BAA4B;IAC5B,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB,qBAAqB;IACrB,mBAAmB;IACnB,yDAAyD;AAC7D;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,gCAAgC;IAChC,0BAA0B;IAC1B,4BAA4B;AAChC;;AAEA;;IAEI,kCAAkC;IAClC,iCAAiC;AACrC;;AAEA;IACI,eAAe;IACf,uBAAuB;AAC3B;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,gBAAgB;IAChB,8BAA8B;IAC9B,cAAc;IACd,oBAAoB;IACpB,uCAAuC;IACvC,qBAAqB;IACrB,eAAe;IACf,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA,yFAAyF;AACzF;IACI,kBAAkB;IAClB,4BAA4B;IAC5B,kCAAkC;IAClC,iCAAiC;IACjC,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,iBAAiB;IACjB,UAAU;IACV,+BAA+B;AACnC;;AAEA,yDAAyD,gCAAgC,EAAE;AAC3F,yDAAyD,gCAAgC,EAAE;;AAE3F;IACI,eAAe;AACnB;;AAEA,2EAA2E;AAC3E;IACI,gBAAgB;IAChB,MAAM;IACN,UAAU;IACV,gCAAgC;IAChC,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,qBAAqB;IACrB,sCAAsC;AAC1C;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,2EAA2E;IAC3E,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,iBAAiB;AACrB;;AAEA,oDAAoD;AACpD;;;IAGI,oBAAoB;AACxB;;AAEA;IACI,4CAA4C;AAChD;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,uCAAuC;IACvC,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,qEAAqE;IACrE,qBAAqB;AACzB;;AAEA,+CAA+C;AAC/C;;;;IAII,mBAAmB;AACvB;;AAEA;IACI;QACI,WAAW;QACX,kCAAkC;IACtC;AACJ;;AAEA,gKAAgK;AAChK;IACI,gBAAgB;IAChB,MAAM;IACN,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,sBAAsB;IACtB,6BAA6B;IAC7B,cAAc;IACd,gEAAgE;IAChE,kCAA0B;YAA1B,0BAA0B;AAC9B;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,sBAAsB;IACtB,gBAAgB;IAChB,4BAA4B;IAC5B,+BAA+B;IAC/B,oBAAoB;IACpB,gCAAgC;IAChC,0BAA0B;IAC1B,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,gEAAgE;AACpE;;AAEA;IACI,uCAAuC;IACvC,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI,KAAK,yBAAyB,EAAE;AACpC;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,sBAAsB;IACtB,iBAAiB;IACjB,oBAAoB;IACpB,uCAAuC;IACvC,qBAAqB;AACzB;;AAEA,uDAAuD;AACvD;IACI,oBAAoB;IACpB,sBAAsB;IACtB,qBAAqB;IACrB,QAAQ;AACZ;;AAEA;IACI,SAAS;IACT,eAAe;IACf,mBAAmB;AACvB;;AAEA,8DAA8D;AAC9D;IACI,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,mBAAmB;AACvB;;AAEA,mDAAmD;AACnD;IACI,6BAA6B;AACjC;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,sBAAsB;IACtB,gCAAgC;IAChC,iBAAiB;IACjB,+BAA+B;IAC/B,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,0BAA0B;IAC1B,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,YAAY;AAChB;;;AAGA,iHAAiH;;AAEjH;IACI,gBAAgB;IAChB,kBAAkB,EAAE,+DAA+D;AACvF;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI;QACI,eAAe;IACnB;;IAEA;QACI,iBAAiB;QACjB,gBAAgB;QAChB,iCAAiC;QACjC,qBAAqB;IACzB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,sBAAsB;IAC1B;AACJ","sourcesContent":["@import './bBookFeedback.css';\n@import './bBookLists.css';\n@import './bBookReport.css';\n\n/* ===== B-book design layer: tokens, shared components, settings page ===== */\n\n/* Status colours tuned for WCAG AA on the admin surfaces: the theme's #22C55E green is 2.3:1 on white, too pale for text */\n.b_book_page {\n    --bb-gain: #15803D;\n    --bb-loss: #B91C1C;\n    --bb-warn: #B45309;\n    --bb-book-b: #D97706;\n    --bb-series-3: #0F766E;\n    --bb-ok-badge: #15803D;\n    --bb-alert-badge: #B91C1C;\n    --bb-soft: var(--text-secondary);\n    --bb-focus: var(--primary);\n    --bb-space-1: 4px;\n    --bb-space-2: 8px;\n    --bb-space-3: 12px;\n    --bb-space-4: 16px;\n    --bb-space-5: 24px;\n    --bb-space-6: 32px;\n}\n\n[data-theme=\"dark\"] .b_book_page {\n    --bb-gain: #4ADE80;\n    --bb-loss: #F87171;\n    --bb-warn: #FBBF24;\n    --bb-book-b: #FBBF24;\n    --bb-series-3: #2DD4BF;\n}\n\n/* keyboard users see where they are: the global stylesheet removes every outline */\n.b_book_page :is(button, a, [role=\"switch\"], summary):focus-visible,\n.b_book_page .b_book_toggle .toggle-checkbox:focus-visible + .toggle-switch {\n    outline: 2px solid var(--bb-focus);\n    outline-offset: 2px;\n}\n\n.b_book_page .tableau_body_item,\n.b_book_page .b_book_num {\n    font-variant-numeric: tabular-nums;\n}\n\n@media (prefers-reduced-motion: reduce) {\n    .b_book_page *,\n    .b_book_page *::before,\n    .b_book_page *::after {\n        transition-duration: 0.01ms !important;\n        animation-duration: 0.01ms !important;\n    }\n}\n\n.b_book_page .b_book_visually_hidden {\n    position: absolute;\n    width: 1px;\n    height: 1px;\n    overflow: hidden;\n    clip: rect(0 0 0 0);\n    white-space: nowrap;\n}\n\n.b_book_page .b_book_icon {\n    flex-shrink: 0;\n}\n\n/* ----- page structure ----- */\n\n.b_book_page .b_book_title_component {\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n    width: 100%;\n    justify-content: space-between;\n    align-items: center;\n    gap: var(--bb-space-3);\n    margin: var(--bb-space-6) 0 var(--bb-space-2);\n}\n\n.b_book_page .b_book_title_component:first-child {\n    margin-top: 0;\n}\n\n.b_book_page .b_book_title_component h2 {\n    margin: 0;\n    font-size: 20px;\n    font-weight: 600;\n}\n\n.b_book_page_title {\n    margin: 0;\n    font-size: 24px;\n    font-weight: 700;\n    letter-spacing: -0.01em;\n    color: var(--text-primary);\n}\n\n.b_book_page .b_book_hint {\n    margin: 0 0 var(--bb-space-4);\n    max-width: 75ch;\n    font-size: 13px;\n    line-height: 1.5;\n    color: var(--bb-soft);\n}\n\n.b_book_page .b_book_card {\n    display: flex;\n    flex-direction: column;\n    gap: var(--bb-space-4);\n    background-color: var(--bg-card);\n    border: 1px solid var(--border);\n    border-radius: var(--radius-md);\n    box-shadow: var(--shadow-sm);\n    padding: var(--bb-space-5);\n    margin-bottom: var(--bb-space-5);\n}\n\n.b_book_page .b_book_card .table-container,\n.b_book_page .b_book_card .table-column {\n    width: 100%;\n}\n\n/* ----- buttons: one primary per form, quiet row actions, destructive ones in red ----- */\n\n.b_book_page .b_book_action_button,\n.b_book_page .b_book_secondary_button,\n.b_book_page .b_book_row_button {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    gap: var(--bb-space-2);\n    min-height: 36px;\n    padding: 0 var(--bb-space-4);\n    border-radius: var(--radius-sm);\n    font-size: 14px;\n    font-weight: 600;\n    white-space: nowrap;\n    cursor: pointer;\n    transition: background-color 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease;\n}\n\n.b_book_page .b_book_action_button {\n    background-color: var(--primary);\n    border: 1px solid var(--primary);\n    color: #fff;\n}\n\n.b_book_page .b_book_action_button:hover:not(:disabled) {\n    background-color: var(--primary-hover);\n    box-shadow: var(--shadow-sm);\n}\n\n.b_book_page .b_book_action_button.b_book_danger_button {\n    background-color: var(--bb-loss);\n    border-color: var(--bb-loss);\n}\n\n[data-theme=\"dark\"] .b_book_page .b_book_action_button.b_book_danger_button {\n    color: #1E293B;\n}\n\n.b_book_page .b_book_secondary_button {\n    background-color: transparent;\n    border: 1px solid var(--border);\n    color: var(--text-primary);\n}\n\n.b_book_page .b_book_secondary_button:hover:not(:disabled) {\n    background-color: var(--bg);\n}\n\n.b_book_page .b_book_row_button {\n    min-height: 32px;\n    padding: 0 var(--bb-space-3);\n    font-size: 13px;\n    background-color: transparent;\n    border: 1px solid var(--border);\n    color: var(--text-primary);\n}\n\n.b_book_page .b_book_row_button:hover:not(:disabled) {\n    background-color: var(--bg);\n    border-color: var(--text-secondary);\n}\n\n.b_book_page .b_book_row_button_danger {\n    color: var(--bb-loss);\n    border-color: color-mix(in srgb, var(--bb-loss) 40%, transparent);\n}\n\n.b_book_page .b_book_row_button_danger:hover:not(:disabled) {\n    background-color: var(--danger-light);\n    border-color: var(--bb-loss);\n}\n\n.b_book_page .b_book_action_button:disabled,\n.b_book_page .b_book_secondary_button:disabled,\n.b_book_page .b_book_row_button:disabled {\n    opacity: 0.45;\n    cursor: not-allowed;\n}\n\n.b_book_page .b_book_link_button {\n    background: none;\n    padding: 0;\n    color: var(--primary);\n    font: inherit;\n    font-weight: 600;\n    text-decoration: underline;\n    cursor: pointer;\n}\n\n/* ----- settings: status card ----- */\n\n.b_book_page .b_book_status_row {\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n    justify-content: space-between;\n    align-items: center;\n    gap: var(--bb-space-3);\n}\n\n.b_book_page .b_book_card > .b_book_status_row ~ .b_book_status_row {\n    padding-top: var(--bb-space-5);\n    border-top: 1px solid var(--border);\n}\n\n.b_book_page .b_book_status_row_top {\n    align-items: flex-start;\n}\n\n.b_book_page .b_book_status_label {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    gap: 10px;\n    min-width: 200px;\n}\n\n.b_book_page .b_book_status_label p {\n    margin: 0;\n    font-weight: 600;\n    color: var(--text-primary);\n}\n\n.b_book_page .b_book_row_hint {\n    margin: calc(var(--bb-space-2) * -1) 0 0;\n    font-size: 13px;\n    color: var(--bb-soft);\n}\n\n.b_book_page .b_book_toggle {\n    position: relative;\n}\n\n/* the shared toggle hides its checkbox with visibility, which also removes it from the keyboard: keep it focusable, just invisible */\n.b_book_page .b_book_toggle .toggle-checkbox {\n    visibility: visible;\n    opacity: 0;\n    position: absolute;\n    inset: 0;\n    width: 100%;\n    height: 100%;\n    margin: 0;\n    cursor: pointer;\n    z-index: 1;\n}\n\n.b_book_page .b_book_toggle_disabled {\n    opacity: 0.6;\n    pointer-events: none;\n}\n\n.b_book_page .b_book_brakes_block {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-end;\n    gap: var(--bb-space-2);\n    flex: 1;\n}\n\n.b_book_page .b_book_brakes {\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n    gap: var(--bb-space-2);\n}\n\n.b_book_page .b_book_brake_notes {\n    list-style: none;\n    margin: 0;\n    padding: 0;\n    gap: var(--bb-space-1);\n    max-width: 60ch;\n    font-size: 13px;\n    color: var(--bb-warn);\n}\n\n.b_book_page .b_book_brake_notes li {\n    display: flex;\n    align-items: flex-start;\n    gap: 6px;\n    width: auto;\n}\n\n.b_book_page .b_book_brake_notes .b_book_icon {\n    margin-top: 2px;\n}\n\n/* ----- forms ----- */\n\n.b_book_page .b_book_form_row {\n    display: block;\n    border: 0;\n    margin: 0;\n    padding: 0;\n    min-width: 0;\n}\n\n.b_book_page .b_book_form_row > legend {\n    float: left;\n    padding: 0;\n    margin: 0;\n}\n\n.b_book_page .b_book_form_fields {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: flex-start;\n    justify-content: flex-end;\n    gap: var(--bb-space-4) var(--bb-space-5);\n}\n\n.b_book_page .b_book_field {\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n    width: 220px;\n}\n\n.b_book_page .b_book_field_label {\n    font-size: 13px;\n    font-weight: 600;\n    color: var(--text-primary);\n}\n\n.b_book_page .b_book_field_control {\n    position: relative;\n}\n\n.b_book_page .b_book_field_control input {\n    width: 100%;\n    min-height: 40px;\n    padding-right: 32px;\n    background-color: var(--bg);\n    font-variant-numeric: tabular-nums;\n}\n\n.b_book_page .b_book_field_control input {\n    -moz-appearance: textfield; /* the spinner arrows sit on top of the unit */\n}\n\n.b_book_page .b_book_field_control input::-webkit-inner-spin-button,\n.b_book_page .b_book_field_control input::-webkit-outer-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n}\n\n.b_book_page .b_book_field_invalid input {\n    border-color: var(--bb-loss);\n}\n\n.b_book_page .b_book_field_invalid input:focus {\n    box-shadow: 0 0 0 3px var(--danger-light);\n}\n\n.b_book_page .b_book_field_unit {\n    position: absolute;\n    right: 12px;\n    top: 50%;\n    transform: translateY(-50%);\n    font-size: 14px;\n    color: var(--bb-soft);\n    pointer-events: none;\n}\n\n.b_book_page .b_book_field_helper,\n.b_book_page .b_book_field_error {\n    margin: 0;\n    font-size: 12px;\n    line-height: 1.45;\n}\n\n.b_book_page .b_book_field_helper {\n    color: var(--bb-soft);\n}\n\n.b_book_page .b_book_field_error {\n    color: var(--bb-loss);\n    font-weight: 500;\n}\n\n.b_book_page .b_book_form_submit {\n    margin-top: 25px; /* lines up with the inputs, under their labels */\n}\n\n.b_book_page .b_book_error_text {\n    margin: 0;\n    font-size: 13px;\n    color: var(--bb-loss);\n}\n\n.b_book_page .b_book_inline_error {\n    margin: 0 0 var(--bb-space-4);\n}\n\n/* table cell inputs (spreads) */\n.b_book_page .b_book_exposure_input {\n    width: 140px;\n    min-height: 36px;\n    background-color: var(--bg);\n    font-variant-numeric: tabular-nums;\n}\n\n.b_book_page .b_book_exposure_input.b_book_input_invalid {\n    border-color: var(--bb-loss);\n}\n\n.b_book_page .b_book_add_row {\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n    align-items: flex-start;\n    gap: var(--bb-space-3);\n}\n\n.b_book_page .b_book_add_row .search_user_container,\n.b_book_page .b_book_add_row .search_ticker_container {\n    flex: 1;\n    min-width: 240px;\n    max-width: 420px;\n}\n\n.b_book_page .b_book_position_gain {\n    color: var(--bb-gain);\n    font-weight: 600;\n}\n\n.b_book_page .b_book_position_loss {\n    color: var(--bb-loss);\n    font-weight: 600;\n}\n\n/* ----- responsive ----- */\n\n@media (max-width: 1100px) {\n    .b_book_page .b_book_form_row > legend {\n        width: 100%; /* still floated: a legend that is not floated sits inside the fieldset border, struck through */\n        margin-bottom: var(--bb-space-3);\n    }\n\n    .b_book_page .b_book_form_fields {\n        clear: both;\n        justify-content: flex-start;\n    }\n\n    .b_book_page .b_book_brakes_block {\n        align-items: flex-start;\n    }\n}\n\n@media (max-width: 768px) {\n    .b_book_page .b_book_card {\n        padding: var(--bb-space-4);\n    }\n\n    .b_book_page .b_book_field {\n        width: 100%;\n    }\n\n    .b_book_page .b_book_form_submit {\n        margin-top: 0;\n        width: 100%;\n    }\n\n    .b_book_page .b_book_add_row .search_user_container,\n    .b_book_page .b_book_add_row .search_ticker_container {\n        max-width: none;\n    }\n}\n\n/* house statement: one flow per line, amount right-aligned */\n.b_book_page .b_book_ledger_lines {\n    display: flex;\n    flex-direction: column;\n    gap: var(--bb-space-2);\n    margin: 0;\n}\n\n.b_book_page .b_book_ledger_line {\n    display: flex;\n    justify-content: space-between;\n    gap: var(--bb-space-3);\n    padding-bottom: var(--bb-space-2);\n    border-bottom: 1px solid var(--border);\n}\n\n.b_book_page .b_book_ledger_line dd {\n    margin: 0;\n    font-weight: 600;\n}\n\n/* ===== 2026-10 refresh: one tab bar across the screens, softer surfaces, denser tables, pill buttons ===== */\n\n.b_book_page {\n    --bb-radius-lg: 16px;\n    --bb-radius-md: 12px;\n    --bb-shadow-card: 0 1px 2px rgba(15, 23, 42, 0.04), 0 8px 24px -16px rgba(15, 23, 42, 0.18);\n    --bb-surface-2: color-mix(in srgb, var(--bg-card) 92%, var(--text-primary) 8%);\n    --bb-accent-soft: color-mix(in srgb, var(--primary) 12%, transparent);\n    /* no width cap: on a wide screen the tables spread out instead of scrolling inside their card; prose keeps its own ch limits */\n}\n\n[data-theme=\"dark\"] .b_book_page {\n    --bb-shadow-card: 0 1px 2px rgba(0, 0, 0, 0.3), 0 12px 32px -20px rgba(0, 0, 0, 0.7);\n}\n\n.b_book_page .b_book_page_title {\n    font-size: 26px;\n    letter-spacing: -0.02em;\n}\n\n.b_book_page .b_book_page_lede {\n    margin-top: calc(var(--bb-space-2) * -1);\n    max-width: 90ch;\n}\n\n.b_book_page .b_book_nav {\n    display: flex;\n    flex-wrap: wrap;\n    gap: var(--bb-space-1);\n    width: fit-content;\n    max-width: 100%;\n    margin: 0 0 var(--bb-space-5);\n    padding: 4px;\n    background-color: var(--bb-surface-2);\n    border-radius: 999px;\n}\n\n.b_book_page .b_book_nav_tab {\n    display: inline-flex;\n    align-items: center;\n    min-height: 34px;\n    padding: 0 var(--bb-space-4);\n    border-radius: 999px;\n    font-size: 13px;\n    font-weight: 600;\n    color: var(--bb-soft);\n    text-decoration: none;\n    white-space: nowrap;\n    transition: background-color 0.15s ease, color 0.15s ease;\n}\n\n.b_book_page .b_book_nav_tab:hover {\n    color: var(--text-primary);\n}\n\n.b_book_page .b_book_nav_tab_active {\n    background-color: var(--bg-card);\n    color: var(--text-primary);\n    box-shadow: var(--shadow-sm);\n}\n\n.b_book_page .b_book_card,\n.b_book_page .b_book_report_card {\n    border-radius: var(--bb-radius-lg);\n    box-shadow: var(--bb-shadow-card);\n}\n\n.b_book_page .b_book_title_component h2 {\n    font-size: 18px;\n    letter-spacing: -0.01em;\n}\n\n.b_book_page .b_book_count {\n    display: inline-flex;\n    align-items: center;\n    min-height: 22px;\n    margin-left: var(--bb-space-2);\n    padding: 0 8px;\n    border-radius: 999px;\n    background-color: var(--bb-accent-soft);\n    color: var(--primary);\n    font-size: 12px;\n    font-weight: 700;\n    vertical-align: middle;\n}\n\n/* KPI tiles: bigger figure, a tone bar on the left instead of colour on the text alone */\n.b_book_page .b_book_kpi {\n    position: relative;\n    padding: 18px 20px 18px 22px;\n    border-radius: var(--bb-radius-md);\n    box-shadow: var(--bb-shadow-card);\n    overflow: hidden;\n}\n\n.b_book_page .b_book_kpi::before {\n    content: '';\n    position: absolute;\n    inset: 0 auto 0 0;\n    width: 4px;\n    background-color: var(--border);\n}\n\n.b_book_page .b_book_kpi:has(.b_book_kpi_gain)::before { background-color: var(--bb-gain); }\n.b_book_page .b_book_kpi:has(.b_book_kpi_loss)::before { background-color: var(--bb-loss); }\n\n.b_book_page .b_book_kpi_value {\n    font-size: 28px;\n}\n\n/* tables: quieter chrome, sticky header, hover row, numbers to the right */\n.b_book_page .tableau_head_item_th {\n    position: sticky;\n    top: 0;\n    z-index: 1;\n    background-color: var(--bg-card);\n    font-size: 11px;\n    font-weight: 700;\n    letter-spacing: 0.06em;\n    text-transform: uppercase;\n    color: var(--bb-soft);\n    border-bottom: 1px solid var(--border);\n}\n\n.b_book_page .tableau_body_row {\n    transition: background-color 0.12s ease;\n}\n\n.b_book_page .tableau_body_row:hover {\n    background-color: var(--bb-surface-2);\n}\n\n.b_book_page .tableau_body_item {\n    border-bottom: 1px solid color-mix(in srgb, var(--border) 60%, transparent);\n    padding-top: 10px;\n    padding-bottom: 10px;\n}\n\n.b_book_page .tableau_body_item:has(> .b_book_num) {\n    text-align: right;\n}\n\n/* buttons: pills, the primary one slightly lifted */\n.b_book_page .b_book_action_button,\n.b_book_page .b_book_secondary_button,\n.b_book_page .b_book_row_button {\n    border-radius: 999px;\n}\n\n.b_book_page .b_book_action_button {\n    box-shadow: 0 1px 2px rgba(15, 23, 42, 0.12);\n}\n\n.b_book_page .b_book_action_button:hover:not(:disabled) {\n    transform: translateY(-1px);\n}\n\n.b_book_page .b_book_row_button:hover:not(:disabled) {\n    background-color: var(--bb-accent-soft);\n    border-color: transparent;\n    color: var(--primary);\n}\n\n.b_book_page .b_book_row_button_danger:hover:not(:disabled) {\n    background-color: color-mix(in srgb, var(--bb-loss) 10%, transparent);\n    color: var(--bb-loss);\n}\n\n/* inputs and selects share the pill language */\n.b_book_page .b_book_field_control input,\n.b_book_page .b_book_chip_input,\n.b_book_page .b_book_toolbar select,\n.b_book_page .b_book_toolbar input {\n    border-radius: 10px;\n}\n\n@media (max-width: 900px) {\n    .b_book_page .b_book_nav {\n        width: 100%;\n        border-radius: var(--bb-radius-md);\n    }\n}\n\n/* the app bar: tabs on the left, refresh on the right; it stays put while the screen below changes (no entrance animation: a stuck one would hide the screen) */\n.b_book_page .b_book_appbar {\n    position: sticky;\n    top: 0;\n    z-index: 3;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: var(--bb-space-3);\n    margin: 0 0 var(--bb-space-5);\n    padding: 4px 0;\n    background-color: color-mix(in srgb, var(--bg) 85%, transparent);\n    backdrop-filter: blur(6px);\n}\n\n.b_book_page .b_book_appbar .b_book_nav {\n    margin: 0;\n}\n\n.b_book_page .b_book_refresh {\n    display: inline-flex;\n    align-items: center;\n    gap: var(--bb-space-2);\n    min-height: 36px;\n    padding: 0 var(--bb-space-4);\n    border: 1px solid var(--border);\n    border-radius: 999px;\n    background-color: var(--bg-card);\n    color: var(--text-primary);\n    font-size: 13px;\n    font-weight: 600;\n    cursor: pointer;\n    transition: background-color 0.15s ease, border-color 0.15s ease;\n}\n\n.b_book_page .b_book_refresh:hover {\n    background-color: var(--bb-accent-soft);\n    border-color: transparent;\n    color: var(--primary);\n}\n\n.b_book_page .b_book_refresh_spinning .b_book_icon {\n    animation: b_book_spin 0.8s linear infinite;\n}\n\n@keyframes b_book_spin {\n    to { transform: rotate(360deg); }\n}\n\n.b_book_page .b_book_pending {\n    display: inline-flex;\n    align-items: center;\n    gap: var(--bb-space-2);\n    padding: 6px 12px;\n    border-radius: 999px;\n    background-color: var(--bb-accent-soft);\n    color: var(--primary);\n}\n\n/* a figure with a note under it, inside a table cell */\n.b_book_page .b_book_stack {\n    display: inline-flex;\n    flex-direction: column;\n    align-items: flex-end;\n    gap: 2px;\n}\n\n.b_book_page .b_book_cell_hint {\n    margin: 0;\n    font-size: 11px;\n    white-space: nowrap;\n}\n\n/* ledger lines: the amount never wraps, the label gives way */\n.b_book_page .b_book_ledger_line dt {\n    min-width: 0;\n}\n\n.b_book_page .b_book_ledger_line dd {\n    flex-shrink: 0;\n    white-space: nowrap;\n}\n\n/* a fold for the detail nobody needs at a glance */\n.b_book_page .b_book_details {\n    margin: 0 0 var(--bb-space-5);\n}\n\n.b_book_page .b_book_details > summary {\n    display: inline-flex;\n    align-items: center;\n    gap: var(--bb-space-2);\n    margin-bottom: var(--bb-space-4);\n    padding: 6px 14px;\n    border: 1px solid var(--border);\n    border-radius: 999px;\n    font-size: 13px;\n    font-weight: 600;\n    color: var(--text-primary);\n    cursor: pointer;\n    list-style: none;\n}\n\n.b_book_page .b_book_details > summary::-webkit-details-marker {\n    display: none;\n}\n\n.b_book_page .b_book_details > summary::before {\n    content: '+';\n    font-weight: 700;\n}\n\n.b_book_page .b_book_details[open] > summary::before {\n    content: '−';\n}\n\n\n/* ===== responsive page: the (i) of a section title sits beside it, the app bar stacks on narrow screens ===== */\n\n.b_book_page .b_book_title_component .b_book_info {\n    position: static;\n    margin-right: auto; /* title and its (i) on the left, the live stamp on the right */\n}\n\n.b_book_page .b_book_title_component h2 {\n    margin-right: var(--bb-space-1);\n}\n\n@media (max-width: 900px) {\n    .b_book_page .b_book_appbar {\n        flex-wrap: wrap;\n    }\n\n    .b_book_page .b_book_appbar .b_book_nav {\n        flex-wrap: nowrap;\n        overflow-x: auto;\n        -webkit-overflow-scrolling: touch;\n        scrollbar-width: none;\n    }\n\n    .b_book_page .b_book_appbar .b_book_nav::-webkit-scrollbar {\n        display: none;\n    }\n\n    .b_book_page .b_book_appbar .b_book_refresh {\n        margin-left: auto;\n    }\n\n    .b_book_page .b_book_title_component {\n        gap: var(--bb-space-2);\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
